<script setup>
import Icon from "@/components/icons/Icon.vue";

const modelValue = defineModel();

defineProps({
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number, Boolean, Object],
    required: true
  },
  srLabel: {
    type: String,
    default: ''
  },
  shape: {
    type: String,
    default: 'check' // 'check' is the only shape currently
  }
});
</script>

<template>
  <div class="jwx-radio-control">
    <input
      type="radio"
      :name="name"
      :id="id"
      class="jwx-radio-control__input jwx-hidden-control"
      v-model="modelValue"
      :value="value"
    />
    <label :for="id" class="jwx-radio-control__label">
      <p class="sr-only">{{ srLabel }}</p>
      <span class="jwx-radio-control__selection-indicator">
        <Icon
          v-if="modelValue === value && shape === 'check'"
          name="checkmark"
          class="jwx-radio-control__indicator-icon"
        />
      </span>
    </label>
  </div>
</template>
